import React from 'react';
import { withTranslation  } from "react-i18next";

let RewardDetails = ({subtitle, location, description, terms, t}) => {
    return <div>
        <h2 className="light detail-subtitle">{subtitle}</h2>

        <p dangerouslySetInnerHTML={{__html: description}}/>
        <p>{location}</p>
        <p>{terms}</p>
    </div>;
}

export default withTranslation() (RewardDetails)